import { render, staticRenderFns } from "./BalancePerPallet.vue?vue&type=template&id=50aa1f12"
import script from "./BalancePerPallet.vue?vue&type=script&lang=js"
export * from "./BalancePerPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports